import React, { useState } from "react";
import { Form } from "react-bootstrap";
import "./AddEmailSidebar.css";
import { ChevronDown } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { generateEmail } from "../../services/email";
import { manageAgentSessionIds } from "../../helpers";
import Loader from "../Common/Loader";

const CreateEmailLeft = ({
  sku,
  setEmailData,
  previewImage,
  templateName,
  onEmailChunk,
  clearStreamingSections,
  tone,
  setTone,
  occasion,
  setOccasion,
  furtherDetails,
  setFurtherDetails,
  setIsLoading,
  isLoading,
  uid
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const initialProductData = location.state?.productData || null;

  const [error, setError] = useState(null);

  const { agentId, sessionId } = manageAgentSessionIds(sku);
  // const [isLoading, setIsLoading] = useState(false);

  const handleOptimize = async () => {
    setIsLoading(true);
    setError(null);

    const payload = {
      preview_image: previewImage,
      request_type: "email",
      additional_data: {
        agent_id: "ag123" + Math.random().toString(36).substring(2, 20),
        session_id: "se_" + Math.random().toString(36).substring(2, 15),
        uid: uid || '',
        template: templateName,
        occasion: occasion,
        tone: tone,
        further_details: furtherDetails,
        streaming: true,
      },
    };

    let accumulatedData = [];

    clearStreamingSections();
    const onDataChunk = (chunk) => {
      if (onEmailChunk) {
        // setIsLoading(false);
        onEmailChunk(chunk);
      }
      accumulatedData.push(chunk);
    };

    const onComplete = () => {
      setIsLoading(false);
      setEmailData({ ...accumulatedData });
    };

    const onError = (err) => {
      setError(err.message || "Failed to optimize email");
      setIsLoading(false);
    };

    try {
      await generateEmail(payload, onDataChunk, onComplete, onError);
    } catch (error) {
      setError(error.message || "Failed to optimize email");
      setIsLoading(false);
    }
  };
  const [keywords, setKeywords] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (["Enter", ","].includes(e.key)) {
      e.preventDefault();
      const value = inputValue.trim();
      if (value && !keywords.includes(value)) {
        setKeywords([...keywords, value]);
        setInputValue("");
      }
    }
  };

  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };

  // const [occasion, setOccasion] = useState("");
  // const [furtherDetails, setFurtherDetails] = useState("");
  // const [loading, setLoading] = useState(false);
  return (
    <div className="edit-product-left1">

      {/* {isLoading && (
        <div
          className="loader-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
pointerEvents: "all",
overflow: "hidden",
          }}
        >
          <Loader />
        </div>
      )} */}

      <h2 className="form-title">Please fill in your information</h2>

      <Form>
        <div className="mainform edit-product-left">
          <div className="form-section ">
            <label className="form-label">Occassion</label>
            {/* <Form.Control
              type="text"
              placeholder="Keywords"
              className="form-input"
            /> */}
            {/* <div className="input-container">
              {keywords.map((keyword, index) => (
                <div key={index} className="keyword-badge">
                  {keyword}
                  <button type="button" className="keyword-remove" onClick={() => removeKeyword(index)}>
                    ×
                  </button>
                </div>
              ))}
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                className="badge-input"
                placeholder={keywords.length === 0 ? "Type and press enter to add" : ""}
              />
            </div> */}
            <Form.Control
              type="text"
              placeholder="e.g. Welcome a new customer"
              className="form-input"
              value={occasion}
              onChange={(e) => setOccasion(e.target.value)}
            />
          </div>

          <div className="form-section">
            <label className="form-label">
              Further details that you would like included here
            </label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Add details about the product"
              className="form-textarea"
              value={furtherDetails}
              onChange={(e) => setFurtherDetails(e.target.value)}
            />
          </div>

          <div className="form-section">
            <label className="form-label">What is the tone of voice?</label>
            <div className="custom-dropdown">
              <Form.Control
                as="select"
                className="form-input"
                value={tone}
                onChange={(e) => setTone(e.target.value)}
              >
                <option value="" disabled>
                  e.g. formal
                </option>
                <option value="formal">Formal</option>
                <option value="informal">Informal</option>
                <option value="friendly">Friendly</option>
                <option value="casual">Casual</option>
                <option value="professional">Professional</option>
                <option value="persuasive">Persuasive</option>
              </Form.Control>
              <ChevronDown className="dropdown-icon" />
            </div>
          </div>
        </div>

        <button
          type="button"
          className="optimize-button mt-2"
          onClick={handleOptimize}
        >
          Optimize
        </button>

        <button type="button" className="documents-button">
          Add additional documents
        </button>
      </Form>
    </div>
  );
};

export default CreateEmailLeft;